export interface IEnviroment {
  apiBaseUrl: string;
  frontBaseUrl: string;
  imagesBaseUrl: string;
}

const getEnv = (): IEnviroment => {
  // eslint-disable-next-line no-restricted-globals
  const host = location.hostname;
  let apiBaseUrl = '';
  let imagesBaseUrl = '';
  let frontBaseUrl = '';


  switch (host) {
    case 'localhost':
      apiBaseUrl = `http://larry.tecdata/planetoffice30/ecommerce/backend/api`;

      // apiBaseUrl = `http://localhost:8061/planetoffice30/ecommerce/backend/api`;
      // imagesBaseUrl = `http://10.2.1.159/planetoffice/2.1/application/ecommerce/frontend/vue/dist/`;
      imagesBaseUrl = `https://planetoffice-img-repo-desa.s3.sa-east-1.amazonaws.com/`;
      frontBaseUrl = host;
      break;

    case 'test.planetoffice.com.ar':
      apiBaseUrl = `/api`;
      imagesBaseUrl = `https://www.planetoffice.com.ar/`;
      frontBaseUrl = host;
      break;

    case 'desa.planetoffice':
      apiBaseUrl = `/api`;
      imagesBaseUrl = `https://planetoffice-img-repo-desa.s3.sa-east-1.amazonaws.com/`;
      frontBaseUrl = host;
      break;

    case 'prod.planetoffice.com.ar':
      apiBaseUrl = `/api`;
      // imagesBaseUrl = `https://planetoffice-img-repo.s3.sa-east-1.amazonaws.com/`;
      imagesBaseUrl = `https://img.planetoffice.com.ar/`;
      frontBaseUrl = host;
      break;

    case 'planetoffice.com.ar':
      apiBaseUrl = `/api`;
      imagesBaseUrl = `https://img.planetoffice.com.ar/`;
      frontBaseUrl = host;
      break;

    case 'www.planetoffice.com.ar':
      apiBaseUrl = `/api`;      
      imagesBaseUrl = `https://img.planetoffice.com.ar/`;
      frontBaseUrl = host;
      break;
          
  

    default:
      apiBaseUrl = `http://larry.tecdata/planetoffice30/ecommerce/backend/api`;
      imagesBaseUrl = `https://planetoffice-img-repo-desa.s3.sa-east-1.amazonaws.com/`;
      frontBaseUrl = host;
  }

  return { apiBaseUrl, imagesBaseUrl, frontBaseUrl };
};

export const env = getEnv();
